function Divider({ className }) {
  return <div className={`bg-main-3 mx-[20px] h-[1px] ${className}`} />
}

export default Divider
